import styled from 'styled-components';

export const CenterContainer = styled.div`
    display: flex;
    width: 100%;
    margin-right: 150px;
    margin-left: 150px;
    justify-content: space-between;
    @media only screen and (max-width: 600px) {
        display: block;
    }
`;